import moment from 'moment'

export const warningMessages = {
  retain: 'The carrier window is before the RETAIN time. This order volume may not fit at the selected time.',
  runout: 'The carrier window end date is after RUNOUT. \n' + 'Tank may runout prior to carrier order completion.',
  outside: 'The carrier window is outside the Dispatch Window. \n' + 'Are you sure?',
}

export const generateCarrierWindowDate = (carrierDate: string | null, defaultDate: string | null) => {
  if (carrierDate) {
    return moment(carrierDate)
  }
  if (defaultDate) {
    return moment(defaultDate)
  }
  return moment().startOf('hour')
}
